import * as React from 'react';
import { useStyles, isNumber } from '@sravni/react-utils';
import { Space } from '../../Space/src/Space.js';
import modules_74c5b1b9 from '../styles/Dialog.module.less.js';
import DialogContext from './DialogContext.js';

/**
 * @description The Dialog component is used to show content on top of an overlay that requires user interaction
 *
 * @component
 * @example
 * ```jsx
 * <Footer>content</Dialog>
 * ```
 */
const Footer = React.forwardRef((props, ref) => {
    const { className, size, direction, justify, children, ...restProps } = props;
    const cx = useStyles(modules_74c5b1b9);
    const { fullscreen } = React.useContext(DialogContext);
    const classNames = cx(className, 'footer', {
        fullscreen,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'default-direction': !direction,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'default-Justify': !justify,
    });
    return (React.createElement(Space, { ref: ref, size: isNumber(size) ? size : 12, direction: direction, justify: justify, className: classNames, ...restProps }, children));
});
Footer.displayName = 'Footer';

export { Footer };
//# sourceMappingURL=Footer.js.map
